import ZkBreadcrumb from './src/breadcrumb';

/* istanbul ignore next */
ZkBreadcrumb.install = function(Vue) {
  Vue.component(ZkBreadcrumb.name, ZkBreadcrumb);
};

export default ZkBreadcrumb;



// WEBPACK FOOTER //
// ./src/packages/breadcrumb/index.js